import React, { useCallback } from 'react';
import { Box, RadioButton, Text } from '@common-fe/common-fe';

import { RoleLevel } from '../../role.types';


interface RolesLevelRadioProps {
  name: string;
  role:RoleLevel ;
  checked: boolean;
  label: string;
  children?: React.ReactNode;
  onChangeValue: (value: RoleLevel) => void;
}
const RolesLevelRadio: React.FC<RolesLevelRadioProps> = ({
  checked,
  name,
  role,
  label,
  children,
  onChangeValue,
}) => {
  const handleChange = useCallback(() => {
    onChangeValue(role);
  }, [onChangeValue, role]);
  return (
    <Box data-testid={`role-list_level_row_${name}`}  pad={{ horizontal: 'xs', vertical: 'xxs' }}>
      <RadioButton
        data-testid={`role-list_level_${name}`}
        name={name}
        checked={checked}
        onChange={handleChange}
        label={(
          <Box margin={{ left: 'xxs' }}>
            <Text>{label}</Text>
          </Box>
        )}
      />
      {children}
    </Box>
  );
};

export default RolesLevelRadio;
